import { createBrowserHistory } from 'history';
import { config } from '../env_config/react-config';

const history = createBrowserHistory();
const initGA = (history) => {
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], 
	j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtag/js?id='+i+dl;f.parentNode.insertBefore(j,f);
	})(window,document,'script','dataLayer', config.googleAnalytisUserId);
  history.listen((location) => {
    console.log("tracking page view: " + location.pathname);
    setTimeout(()=>{
      dataLayer.push({'event': 'pageview', 'location': location.pathname + location.search, "pageTitle": document.querySelector("title").innerText} );
    }, 2000);
  });
};

initGA(history);

export default history;